<template>
  <v-col
    cols="12"
    sm="6"
    align-self="center"
    class="d-flex justify-center justify-sm-start"
  >
    <p class="f-16 sz-secondary-grey--text font-weight-medium d-inline-block mb-0">
      {{ $t('label.perPage') }}:
    </p>
    <p
      v-for="(item, index) in props.limitList"
      :key="index"
      :class="{ 'primary-link' : currentLimit !== item }"
      class="f-16 font-weight-medium d-inline-block ml-2 pointer text-black mb-0"
      @click="setLimit(item)"
    >
      {{ item }}
    </p>
  </v-col>
</template>

<script setup lang="ts">
import { defineModel } from 'vue';

type Props = {
    limitList: number[];
}

const props = defineProps<Props>();

const currentLimit = defineModel<number>();

const setLimit = (limit: number) => {
    currentLimit.value = limit;
};
</script>
